import React, { useContext, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import { IconButton, Typography } from "@mui/material";
import { checkIsRoleAllowed } from "../utils/SecurityUtils";
import { useSelector } from "react-redux";
import { isComponentDisabled, isComponentVisible } from "../utils/SaitUtils";
import { ModuleContext } from "../utils/Constants";

/*
	Obbligatori:
		id
		icon
		onClick
	Facoltativi:
		conditionalRendering
		tooltip
*/

function WaitButton(props) {
	const [executing, setExecuting] = useState(false);

	const onRealClick = async (event) => {
		setExecuting(true);
		try {
			await props.onClick(props.params);
		} finally {
			setExecuting(false);
		}
	};

	return (
		<IconButton onClick={onRealClick} disabled={props.disabled || executing}>
			{React.cloneElement(props.icon, {
				color: props.disabled || executing ? "gray" : props.icon.props.color,
			})}
		</IconButton>
	);
}

function SaitRowActionCell({ config, params }) {
	const userPreferences = useSelector((state) => state["auth"]);
	const componentModule = useContext(ModuleContext);

	const objModArray = userPreferences["objMod"] ?? [];
	const objMod = objModArray.find((objModObject) => objModObject.moduleName === componentModule && objModObject.idObject === config.objmod);

	const isAllowed = checkIsRoleAllowed(config.roleSecurity, userPreferences);
	const isVisible = !config.conditionalRendering || config.conditionalRendering(params);
	const isVisibleObjMod = isComponentVisible(objMod, false);

	if (!isAllowed || !isVisible || !isVisibleObjMod) return null;

	return (
		<Tooltip title={<Typography fontSize={14}>{config.tooltip}</Typography>}>
			<span>
				<WaitButton onClick={config.onClick} icon={config.icon} params={params} disabled={isComponentDisabled(objMod, false)} />
			</span>
		</Tooltip>
	);
}

export default SaitRowActionCell;
